import { createReducer } from '@reduxjs/toolkit';

import { setServerRedirect } from 'Core/actions/response';

export default createReducer<string | null>(null, (builder) =>
  builder.addCase(setServerRedirect, (_state, { payload }) => payload),
);
